

import React from 'react'
import Subscription from './Subscription'


function Home() {



    return (

        <>
            {/* <div>Home</div> */}

            <Subscription />

        </>
    )
}

export default Home


